import * as React from 'react';

const FooterLink = ({ href, text }: { href: string; text: string }) => {
	return (
		<a className="globalFooterText" href={href} target="_blank" rel="noreferrer">
			{text}
		</a>
	);
};

export default FooterLink;
